module.exports = __webpack_public_path__ + "public/SiteIcons/information-button-black.svg?b7d2ec81";